module.exports = __webpack_public_path__ + "img/banner_news_page.c8ed7250.png";